import Container from './HybridActivityLog';
export default Container;

export const componentName = 'HybridActivityLog';
